<template>
  <div>
    <PpcHeader :contactPhone="ppcPhone" :bLocation="franchiseCityState" />
    <div class="container bg-white mx-auto p-0" v-if="isPremiumPackage">

      <!-- Form -->
      <DefaultQuoteForm :ppcData="ppcData" :reviews="reviews" :errors="errors" :currentPackage="currentPackage"
        :isFormSubmitProcessing="isFormSubmitProcessing" @submit="handleFormSubmit" ref="formComponent" :isPremiumPackage="isPremiumPackage" />

      <div class="hidden md:block">
        <!--- Why Choose Preminum Package -->
        <PPChoose :ppcData="ppcData" :urlLocation="urlLocation" :currentPackage="currentPackage"/>

        <!-- Healthier -->
        <Curves background="fff" foreground="EEF1F4" location="topRight" />
        <div class="container bg-gray-200">
          <PPHealthier :imageSrc="urlLocation + ppcData.marketing_block_6_image" :currentPackage="currentPackage"
            :heading="ppcData.marketing_block_6_heading" :description="ppcData.marketing_block_6_copy"
            primaryButtonText="Get a Free Quote" @scroll-to-form="notifyFormComponent" />
        </div>
        <Curves background="fff" foreground="EEF1F4" location="bottomRight" />

        <!--Established -->
        <Curves background="fff" foreground="fff" location="bottomRight" />
        <div class="container bg-white pr-12 pl-0">
          <PPEstablished :backgroundImage="`${$config.public.sgCmsImage + ppcData.marketing_block_5_image}`"
            :logoImage="urlLocation + ppcData.marketing_block_4_image" :mainHeading="ppcData.marketing_block_4_heading"
            :subHeading="ppcData.marketing_block_4_copy" :description="ppcData.marketing_block_5_copy" :currentPackage="currentPackage"/>
        </div>
        <Curves background="fff" foreground="fff" location="bottomRight" />

        <!--- Stand Out -->
        <PPStandsOut :ppcData="ppcData" :urlLocation="urlLocation" :currentPackage="currentPackage" />
        <Curves background="fff" foreground="fff" location="bottomRight" />
      </div>

    </div>

    <div class="container bg-white mx-auto p-0" v-else>

      <DefaultQuoteForm :ppcData="ppcData" :reviews="reviews" :errors="errors"
        :isFormSubmitProcessing="isFormSubmitProcessing" @submit="handleFormSubmit" :isPremiumPackage="isPremiumPackage" />

      <div class="hidden md:block">
        <Curves background="EEF1F4" foreground="fff" location="bottomRight"
          v-if="(featuredServices && featuredServices.length > 0)" />
        <Curves background="fff" foreground="EEF1F4" location="topLeft"
          v-if="(featuredServices && featuredServices.length > 0)" />

        <div class="mx-auto bg-gray-200 px-8 py-1" v-if="(featuredServices && featuredServices.length > 0)">
          <div class="w-full">

            <h2 class="text-center mb-8" v-if="featuredServices && featuredServices.length > 0">Recommended Services</h2>

            <ServicesCardList v-if="featuredServices && featuredServices.length > 0" :services="featuredServices"
              borderOverride="green" :hidePurchased="true" size="small" />

          </div>
        </div>

        <Curves background="fff" foreground="EEF1F4" location="bottomLeft"
          v-if="(featuredServices && featuredServices.length > 0)" />
        <Curves background="EEF1F4" foreground="fff" location="topRight"
          v-if="(featuredServices && featuredServices.length > 0)" />

        <div class="grid grid-cols-1 md:grid-cols-2 gap-8 md:pb-10" v-if="franchiseLocation">
          <div class="ps-0 md:pl-8 fcard">
            <FranchiseFranchiseeCard :name="signature" :location="franchiseLocation" :franchiseeImageSrc="franchiseeImg"
              :signatureImageSrc="franchiseeImg" :phone="ppcPhone" />
            <p class="green font-bold py-4 px-3 md:px-0">
              We'd be happy to take care of your yard.<br />
            </p>
            <p class="mt-4 px-3 md:px-0" v-if="userAddress">
              Your address: <br />
              <strong>{{ userAddress }}</strong>
            </p>
          </div>
          <div class="md:pr-8 px-3">
            <div v-if="franchiseeBio" v-html="franchiseeBio"></div>
          </div>
        </div>

        <Curves background="EEF1F4" foreground="fff" location="bottomRight" />
        <Curves background="fff" foreground="EEF1F4" location="topLeft" />

        <DefaultStandsOut :ppcData="ppcData" :urlLocation="urlLocation" />

        <Curves background="fff" foreground="EEF1F4" location="bottomLeft" />
        <Curves background="EEF1F4" foreground="fff" location="topRight" />

        <div class="text-center font-bold text-base" v-if="ppcData.reviews_block_cta && ppcData.reviews_block_cta !== null">
          {{ ppcData.reviews_block_cta }}
          <img loading="lazy" src="~/assets/images/Google_2015_logo 1.png" alt="google logo" class="inline-block ml-1" />
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, computed, onMounted, type Ref } from 'vue';
import { useRoute, useNuxtApp } from '#app';
import { useStore } from 'vuex';
import type { Store } from 'vuex/types/index.js';
import DefaultStandsOut from "./DefaultStandsOut.vue";
import DefaultQuoteForm from "./DefaultQuoteForm.vue";
import PPHealthier from "./PPHealthier.vue";
import PPEstablished from "./PPEstablished.vue";
import PPStandsOut from "./PPStandsOut.vue";
import PPChoose from "./PPChoose.vue";
import PpcHeader from "~/components/PpcHeader.vue";
import type State from '~/domains/store/State';
import type ServiceState from '~/domains/store/services/ServiceState';
import type { PpcContactForm } from '~/domains/ppc/PpcContactForm';

const props = defineProps({
  ppcData: { type: Object, required: true },
  reviews: Array,
  errors: { type: Array<string>, default: () => [] },
  isFormSubmitProcessing: Boolean
});

const emit = defineEmits(['submit']);

const nuxtApp = useNuxtApp();
const { $sg, $services, $config } = nuxtApp;
const store: Store<State> = useStore();
const route = useRoute();

const urlLocation = ref($config.public.sgCmsImage);
const youtubeLink = ref("");
const franchiseInfo = ref<any[] | null>(null);
const featuredServices = ref<ServiceState[]>();
const signature = ref("");
const franchiseCityState = ref("");
const franchiseLocation = ref("");
const franchiseeImg = ref("");
const franchiseeBio = ref("");
const ppcPhone = ref("");
const userAddress = ref("");

const formComponent: Ref<HTMLElement | null> = ref(null);

const branchInfo = computed(() => store.state.persistedState?.branchInfo);

const isPremiumPackage = computed(() => {
  return !!route.query.utm_content && (props.ppcData?.package_id);
});

const currentPackage = computed(() => {
  return props.ppcData?.package_id;
});


onMounted(async () => {
  const persistedState = store.state.persistedState;
  userAddress.value = persistedState.userAddress;
  
  if (props.ppcData?.ppc_youtube_video_shortcode) {
    youtubeLink.value = `https://www.youtube.com/embed/${props.ppcData?.ppc_youtube_video_shortcode}`;
  }

  const routeQuery = route.query.utm_content;
  if (routeQuery) {
    const franchiseInfoData = await $sg.getOctoberData('franchise/' + routeQuery);
    const franchiseData = franchiseInfoData?.find((franchise) => Number(franchise.parent_id) === 0) ?? franchiseInfoData?.[0];
    franchiseInfo.value = franchiseInfoData;
    const allServiceIds = JSON.parse(JSON.stringify(franchiseData?.services_to_display));

    const franchiseServices = $services.getServicesByIds(allServiceIds, false, false);
    if (store.state.persistedState.scope?.id) {
      $services.sortServices(franchiseServices);
      featuredServices.value = franchiseServices?.splice(0, 3);
    } else {
      featuredServices.value = franchiseServices.filter((service) => [2, 3].includes(service.ServiceDefId));
    }

    franchiseLocation.value = franchiseData?.name;
    franchiseCityState.value = franchiseData?.city_state_override;
    franchiseeImg.value = '' + $config.public.sgCmsImage + franchiseData?.franchise_owner_image;
    franchiseeBio.value = franchiseData?.local_information;
  }

  if (branchInfo.value) {
    const branchPhoneField = branchInfo.value.BranchInfo?.InfoData?.find(
      (data) => data.FieldName === "MarchEX Digital Phone"
    );
    ppcPhone.value = branchPhoneField?.FieldValue ?? "";

    const signatureData = branchInfo.value.BranchInfo?.InfoData?.find(
      (data) => data.FieldName === "Franchise Owner Name"
    );
    signature.value = signatureData?.FieldValue ?? "";

    if (!franchiseCityState.value) {
      franchiseCityState.value = store.state.persistedState.branchLocation;
    }
  }

  // if (ppcPhoneData && ppcPhoneData.length !== 0) {
  //   const ppcPhoneHref = ppcPhoneData.replaceAll(/\D/g, "");
  //   const ppcNumberElements = nuxtApp.$el.querySelectorAll('.ppc-number');
  //   ppcNumberElements.forEach(element => {
  //     element.innerHTML = '<a class="ppc-link" href="tel:' + ppcPhoneHref + '">' + ppcPhoneData + '</a>';
  //   });
  // }
});

const handleFormSubmit = (formData: PpcContactForm) => {
  emit("submit", formData);
};

const notifyFormComponent = () => {
  if (formComponent && formComponent.scrollToForm) {
    formComponent?.scrollToForm();
  }
};
</script>


<style scoped>
.landing-image-width img
{
  width: 100%;
}

.landing-background-image  {
  background-position: left -71px; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: 1440px 641px; /* Resize the background image to cover the entire container */
  height: 500px;
  border-bottom-left-radius: 70px;
}

.transleaf {
  max-height: 291px;
  max-width: 506px;
  background: linear-gradient(
    180deg,
    rgba(91, 179, 94, 0.309412) 0%,
    #5bb35e 100%
  );
  border-bottom-right-radius: 99px;
  border-top-left-radius: 99px;
  margin: 4em;
}

.transleaf h2 {
  font-style: normal;
  font-weight: 600;
  font-size: 36px;
  line-height: 40px;
}

.quote {
  background: #f7f7f7;
  border-radius: 36px;
  margin: 4em;
  padding: 1em 2em;
}

.quote h3 {
  font-style: normal;
  font-weight: 600;
  font-size: 26px;
  line-height: 32px;
  text-align: center;
  color: #517185;
  margin-top: 1rem;
}

.quote p {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: #517185;
}

.text h2 {
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  font-size: 26px;
  line-height: 32px;
  color: #517185;
  font-display: swap;
}

.text h3 {
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  color: #517185;
}

.bg-gray-200 {
  background-color: #eef1f4;
}

h4 {
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #00810e;
  font-display: swap;
}

button {
  background: #00810e;
  border-radius: 100px;
  font-family: Poppins;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #ffffff;
  font-display: swap;
}

.reviews-inner {
  background: #fff;
  border-bottom-left-radius: 70px;
  padding: 0 0 40px;
}

@media (max-width: 1120px) {
  .transleaf {
    min-height: 220px;
    margin: 2em;
  }

  .quote {
    margin: 0.5em 1em;
  }
}

@media (max-width: 767px) {
  .transleaf h2 {
    font-size: 30px;
    line-height: 1.2;
    margin-top: 30px;
  }
}

.validation-error {
  color: #CE4200;
}

.checkbox {
  display: grid;
  grid-template-columns: min-content auto;
  grid-gap: 0.5em;
}

.checkbox__control {
  display: inline-grid;
  width: 1em;
  height: 1em;
  border-radius: 0.25em;
  border: 0.1em solid #00810e;
  background: #fff;
  color: white;
  margin-top: -3px;
}

.checkbox__control svg {
  transition: transform 0.1s ease-in 25ms;
  transform: scale(0);
  transform-origin: bottom left;
}

.checkbox__input {
  display: grid;
  grid-template-areas: "checkbox";
}

.checkbox__input input {
  opacity: 0;
  width: 0;
  height: 0;
}

.checkbox__input input:checked + .checkbox__control svg {
  transform: scale(1);
}

.checkbox__input input:checked + .checkbox__control {
  background: #00810e;
}
</style>
